export interface JwtPayloadDmInterface {
  id?: string;
  urlName?: string;
}
